var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useRef, useState } from 'react';
import submitFile from './actions/submitFile';
const UploadDocumentContext = createContext({});
const UploadDocumentProvider = (props) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [successfulUploads, setSuccessfulUploads] = useState([]);
    const [failedUploads, setFailedUploads] = useState([]);
    const successfulUploadsRef = useRef([]);
    const failedUploadsRef = useRef([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const incrementSuccessCounter = (file, txId) => {
        const successfulUpload = { fileName: file.name, txId };
        setSuccessfulUploads([...successfulUploadsRef.current, successfulUpload]);
        successfulUploadsRef.current.push(successfulUpload);
    };
    const incrementFailedCounter = (file) => {
        setFailedUploads([...failedUploadsRef.current, file.name]);
        failedUploadsRef.current.push(file.name);
    };
    const submitFiles = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedFiles.length)
            return;
        setUploadInProgress(true);
        setSuccessfulUploads([]);
        successfulUploadsRef.current = [];
        setFailedUploads([]);
        failedUploadsRef.current = [];
        const uploadPromises = selectedFiles.map(file => submitFile(file)
            .then((txId) => incrementSuccessCounter(file, txId))
            .catch(() => incrementFailedCounter(file)));
        yield Promise.all(uploadPromises);
        setUploadComplete(true);
        setUploadInProgress(false);
    });
    const resetModel = () => {
        setUploadInProgress(false);
        setUploadComplete(false);
        setSuccessMessage('');
        setErrorMessage('');
        setSelectedFiles([]);
        setSuccessfulUploads([]);
        successfulUploadsRef.current = [];
        setFailedUploads([]);
        failedUploadsRef.current = [];
    };
    const value = {
        selectedFiles,
        setSelectedFiles,
        submitFiles,
        uploadInProgress,
        uploadComplete,
        successfulUploads,
        failedUploads,
        successMessage,
        errorMessage,
        resetModel,
    };
    return React.createElement(UploadDocumentContext.Provider, Object.assign({ value: value }, props));
};
const useUploadDocument = () => {
    const context = useContext(UploadDocumentContext);
    if (!context) {
        throw new Error('UploadDocumentContext must be used inside of a UploadDocumentProvider');
    }
    return context;
};
export { UploadDocumentProvider, useUploadDocument, };
